/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutWithLeftBlockImage.vue?vue&type=template&id=24d2aee0"
import script from "./LayoutWithLeftBlockImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutWithLeftBlockImage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports